const NAME = 'sidebar';

export { NAME };

export const INDEX_NONE = -1;
export const INDEX_CATALOG = 0;
export const INDEX_CATALOG_INSTITUTIONS = 1;
export const INDEX_SEARCH = 2;
export const INDEX_INTERVIEW = 3;
export const INDEX_REGISTRY_ENTRIES = 4;
export const INDEX_MAP = 5;
export const INDEX_WORKBOOK = 6;
export const INDEX_INDEXING = 7;
export const INDEX_ADMINISTRATION = 8;
export const INDEX_PROJECT_ACCESS = 9;
export const INDEX_PROJECTS = 10;
export const INDEX_INSTITUTIONS = 11;
export const INDEX_HELP_TEXTS = 12;
